import Checkbox from '../../../../atoms/Checkbox';
import { Typography } from '../../../../molecules/Typography';
import { usePrintComponentRequestStore } from '../../store/usePrintComponentRequest';

interface IAdicionalFilters {
  disabled: boolean;
  subject: string;
}

const AditionalFilters: React.FC<IAdicionalFilters> = ({
  disabled,
  subject,
}) => {
  const {
    setDifficulty,
    setFavorites,
    setUnanswered,
    setRightAnswer,
    setWrongAnswer,
    // setQuestionOptions,
    difficulty,
    favorites,
    unanswered,
    rightAnswer,
    wrongAnswer,
    // questionOptions,
  } = usePrintComponentRequestStore();

  const difficultyHandler = (level: string) => {
    if (difficulty.indexOf(level) >= 0) {
      const array = [...difficulty];

      array.splice(difficulty.indexOf(level), 1);
      setDifficulty(array);
    } else {
      const array = [...difficulty];
      array.push(level);

      setDifficulty(array);
    }
  };

  // const questionHandler = (type: string) => {
  //   if (questionOptions.indexOf(type) >= 0) {
  //     const array = [...difficulty];

  //     array.splice(questionOptions.indexOf(type), 1);
  //     setQuestionOptions(array);
  //   } else {
  //     const array = [...questionOptions];
  //     array.push(type);

  //     setQuestionOptions(array);
  //   }
  // };

  return (
    <div className='flex flex-col gap-xl'>
      <Typography weight='bold'>
        Utilize os filtros para definir quais exercícios sobre o assunto{' '}
        {subject} você irá imprimir:
      </Typography>

      <div className={'flex flex-col gap-lg'}>
        <Typography weight='bold' size='small' className='mb-1'>
          FILTROS
        </Typography>
        <div className='flex justify-between gap-xl rounded-md bg-color-lighter xs:flex-col md:flex-row'>
          <div className='flex flex-1 flex-col gap-xl p-4'>
            <Checkbox
              onChange={() => difficultyHandler('easy')}
              label='Exercícios fáceis'
              checked={difficulty.indexOf('easy') >= 0}
              id='difficulty-easy'
              value='easy'
              variant='rounded'
              disabled={disabled}
            />
            <Checkbox
              onChange={() => difficultyHandler('medium')}
              label='Exercícios médios'
              checked={difficulty.indexOf('medium') >= 0}
              id='difficulty-medium'
              value='medium'
              variant='rounded'
              disabled={disabled}
            />
            <Checkbox
              onChange={() => difficultyHandler('hard')}
              label='Exercícios difíceis'
              checked={difficulty.indexOf('hard') >= 0}
              id='difficulty-hard'
              value='easy'
              variant='rounded'
              disabled={disabled}
            />
          </div>
          <div className='flex flex-1 flex-col gap-xl p-4'>
            <Checkbox
              onChange={() => setFavorites(!favorites)}
              label='Exercícios favoritados'
              checked={favorites}
              id='favorites'
              value='favorites'
              variant='rounded'
              disabled={disabled}
            />
            <Checkbox
              onChange={() => setUnanswered(!unanswered)}
              label='Apenas exercícios não respondidos'
              checked={unanswered}
              id='unanswered'
              value='unanswered'
              variant='rounded'
              disabled={disabled}
            />
            <Checkbox
              onChange={() => setRightAnswer(!rightAnswer)}
              label='Exercícios que acertei'
              checked={rightAnswer}
              id='rightAnswer'
              value='rightAnswer'
              variant='rounded'
              disabled={disabled}
            />
            <Checkbox
              onChange={() => setWrongAnswer(!wrongAnswer)}
              label='Exercícios que errei'
              checked={wrongAnswer}
              id='wrongAnswer'
              value='wrongAnswer'
              variant='rounded'
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AditionalFilters;
